export function buildScheduleWindow(scheduledStart, existingEnd = null) {
    const start = new Date(scheduledStart);
    if (!scheduledStart || Number.isNaN(start.getTime())) {
        throw new Error('Enter a valid pickup date and time.');
    }

    const end = existingEnd ? new Date(existingEnd) : null;
    const validEnd = end && !Number.isNaN(end.getTime()) && end > start
        ? end
        : new Date(start.getTime() + 60 * 60 * 1000);

    return {
        scheduled_start: start.toISOString(),
        scheduled_end: validEnd.toISOString(),
    };
}
